import ModalCustom from '@ui/modal/ModalCustom';
import React from 'react';
import PointsReordersMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointsReorders/PointsReordersMutateSingleVoyage";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import {useTranslation} from 'react-i18next';

const PointsReordersMutateSingleVoyageModal = () => {

   const{t} = useTranslation()

    return (
        <ModalCustom
            component={<PointsReordersMutateSingleVoyage/>}
            label={t('singleVoyage.reorderPoints')}
            button={<IconButtonCustom
                size={'large'}
            >
                <ViewQuiltIcon/>
            </IconButtonCustom>}
        />
    );
};

export default PointsReordersMutateSingleVoyageModal;